import * as React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { formatPhoneNumber } from '../../utils/string-utils'
import { LandingPageButton } from '../../LandingPageButton'
import { faMoneyCheckEditAlt } from '@fortawesome/pro-duotone-svg-icons'
import { faCalendarCheck } from '@fortawesome/pro-duotone-svg-icons/faCalendarCheck'
import { faCarMechanic } from '@fortawesome/pro-duotone-svg-icons/faCarMechanic'
import { Container } from '../../Container'

type Props = {
  title: string
  description: string
  steps?: { title: string; description: string; image: string }[]
  buttonText?: string
  phoneNumber?: string
}

export const ServicesHowItWorksSection: React.FC<Props> = ({ title, description, steps, buttonText, phoneNumber }) => {
  return (
    <div className="px-2 md:px-8">
      <div className='flex flex-col justify-center justify-items-center content-center items-center self-center place-items-center'>
        <h2 className="title">{title}</h2>
        <p className="description">{description}</p>
      </div>
      <Container>
        <div
          className="grid md:grid-cols-3"
          style={{
            background: 'white',
            boxShadow:
              '0 13px 27px -5px rgba(50, 50, 93, .25), 0 8px 16px -8px rgba(0, 0, 0, .3), 0 -6px 16px -6px rgba(0, 0, 0, .025)',
          }}
        >
          {steps && steps.map(v=>({...v, stepImage: v.image})).map((value, index) => <HowItWorksStep key={index} {...value} />)}
        </div>
      </Container>
      {buttonText && (
        <div className="pt-5 flex flex-col justify-center justify-items-center content-center items-center self-center place-items-center">
          <LandingPageButton buttonText={buttonText} />
        </div>
      )}
      {phoneNumber && (
        <div className={'mt-2'}>
          Or call us at <a href={`tel:${phoneNumber}`}>{formatPhoneNumber(phoneNumber)}</a>
        </div>
      )}
    </div>
  )
}

const HowItWorksStep: React.FC<{
  title: string
  description: string
  stepImage?: string
}> = ({ title, description, stepImage }) => {

  console.log("stepImage", stepImage, stepImage === 'faCarMechanic')
  return (
    <div className="py-4 flex flex-grow-1 flex-col h-100 text-center px-6" style={{ border: '1px solid #dddddd' }}>
      <div className="mx-auto">
        {stepImage === 'faMoneyCheckEditAlt' && (
          <FontAwesomeIcon size={'4x'} color={'#ea3616'} icon={faMoneyCheckEditAlt} />
        )}
        {stepImage === 'faCalendarCheck' && <FontAwesomeIcon size={'4x'} color={'#ea3616'} icon={faCalendarCheck} />}
        {stepImage === 'faCarMechanic' && <FontAwesomeIcon size={'4x'} color={'#ea3616'} icon={faCarMechanic} />}
      </div>
      <div className="mt-3">
        <h3>{title}</h3>
        <p className="description">{description}</p>
      </div>
    </div>
  )
}
